import { NodeType } from '../../../../../model';
import { NodeTreeState, NodeDescriptor } from '@myua/nodetree';
import { CHNode } from '../../../../../node';
export const rootNodeID = -1;
export type CompressedFileTreeProviderOptions = {
  loadTreeURL: string;
  fileURLGetter: (path: string) => string;
  /**
   * Можно ли открывать (= извлекать) отдельные файлы из архива. `false` — у архива
   * закрыто скачивание (напр. лицензии его шрифтов ещё не одобрены юристом): структуру
   * смотреть можно, кнопки Open у записей нет.
   *
   * Не косметика: бэкенд на извлечение файла из такого архива отвечает 403
   * (`FontLicenseChecker.can_download` в `get_archive_file_downloading_response`), а
   * структура архива отдаётся без проверки. Значение по умолчанию (поле не задано) —
   * разрешено.
   */
  openEntriesAllowed?: boolean;
};

type CompressedNode = {
  id: number;
  name: string;
  path: string;
  is_dir: boolean;
  children: CompressedNode[];
};

export type FakeCHNode = CHNode & { path: string };

export type ProviderResult = { nodes: CompressedNode[] };

const cnodeToCHNode = (cnode: CompressedNode): FakeCHNode => ({
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  flags: [],
  id: cnode.id,
  name: cnode.name,
  perms: [],
  size: 0,
  tags: [],
  type: cnode.is_dir ? NodeType.folder : NodeType.file,
  path: cnode.path,
  download_url: null,
  can_download_direct: false,
  direct_source: null,
  preview_url: null,
});

export const providerToContentsShape = (
  provider: ProviderResult,
  filename = 'root',
): NodeTreeState<FakeCHNode>['contents'] => {
  const contents: NodeTreeState<FakeCHNode>['contents'] = {};

  const walk = (cnode: CompressedNode, parentID: number | null, expand: boolean) => {
    const desctiptor: NodeDescriptor<FakeCHNode> = {
      node: cnodeToCHNode(cnode),
      descendants: cnode.is_dir ? cnode.children.map((ch) => cnodeToCHNode(ch)) : [],
      expanded: expand,
      parentNodeID: parentID,
    };
    contents[cnode.id] = desctiptor;
    if (cnode.is_dir) {
      cnode.children.forEach((childCompressedNode) =>
        walk(childCompressedNode, cnode.id, cnode.children.length === 1),
      );
    }
  };

  const rootNode: CompressedNode = {
    id: rootNodeID,
    children: provider.nodes,
    is_dir: true,
    name: filename,
    path: '',
  };

  walk(rootNode, null, true);

  return contents;
};
